import React, { useCallback, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { Modal, List } from 'antd';

const KeyboardShortcutHandler = ({ history, GET_KEYBOARD_SHORTCUTS_DATA }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  // const shortcuts = GET_KEYBOARD_SHORTCUTS_DATA;  //need to be removed later when keyboard shortcut will deploy.

  // temporarily enabled for global search only
  const shortcuts = [
    {
      name: 'Search Global',
      url: null,
      cta_id: 'global-search-button',
      key: '/',
    },
  ];
  const handleKeyPress = useCallback(
    (event) => {
      // Check if the event is happening inside an input, textarea, or contenteditable element
      const { target } = event;
      if (
        target.tagName === 'INPUT'
        || target.tagName === 'TEXTAREA'
        || target.isContentEditable
      ) {
        return;
      }

      // Construct the pressed key combination
      const keyCombination = [
        event.shiftKey ? 'Shift' : null,
        event.ctrlKey ? 'Ctrl' : null,
        event.altKey ? 'Alt' : null,
        event.metaKey ? 'Meta' : null,
        event.key,
      ]
        .filter(Boolean)
        .join('+');

      // {/*
      // //temporarily disabled for global search only need to be removed later when keyboard shortcut will deploy.
      // // Check for shortcut to toggle modal visibility
      // if (keyCombination === 'Shift+?') {
      //   event.preventDefault();
      //   setIsModalVisible((prev) => !prev);
      //   return;
      // }

      // // Form-specific actions
      // if (keyCombination === 'Ctrl+d') {
      //   event.preventDefault();
      //   const draftButton = document.querySelector('#save-as-draft');
      //   if (draftButton) {
      //     draftButton.click();
      //   }
      //   return;
      // }

      // if (keyCombination === 'Ctrl+s') {
      //   event.preventDefault();
      //   const issueButton = document.querySelector('#save-and-issue');
      //   if (issueButton) {
      //     issueButton.click();
      //   }
      //   return;
      // }
      // if (keyCombination === 'Shift++') {
      //   event.preventDefault();
      //   const issueButton = document.querySelector('#quick-create-button');
      //   if (issueButton) {
      //     issueButton.click();
      //   }
      //   return;
      // }
      // */}

      // Find the matching shortcut and navigate to the specified URL
      const shortcut = shortcuts.find((s) => s.key === keyCombination);
      if (shortcut) {
        event.preventDefault();
        if (shortcut.cta_id) {
          event.preventDefault();
          const issueButton = document.querySelector(`#${shortcut.cta_id}`);
          if (issueButton) {
            issueButton.click();
          }
        } else if (shortcut.url) {
          history.push(shortcut.url);
        }
      }
    },
    [shortcuts, history],
  );

  useEffect(() => {
    // Attach the event listener
    document.addEventListener('keydown', handleKeyPress);

    // Clean up the event listener on unmount
    return () => {
      document.removeEventListener('keydown', handleKeyPress);
    };
  }, [handleKeyPress]);

  return (
    <React.Fragment>
      <Modal
        title="Keyboard Shortcuts"
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        footer={null}
      >
        <List
          dataSource={shortcuts}
          renderItem={(item) => (
            <List.Item>
              <div style={{
                display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%',
              }}
              >
                <span>{item.name}</span>
                <div>
                  {item.key.split('+').map((keyPart, index) => (
                    <span
                      key={index}
                      style={{
                        display: 'inline-block',
                        padding: '4px 8px',
                        margin: '0 4px',
                        borderRadius: '6px',
                        backgroundColor: '#333',
                        color: '#fff',
                        fontWeight: 'bold',
                        fontFamily: 'monospace',
                        fontSize: '12px',
                      }}
                    >
                      {keyPart}
                    </span>
                  ))}
                </div>
              </div>
            </List.Item>

          )}
        />
      </Modal>
    </React.Fragment>
  );
};

const mapStateToProps = ({
  UserReducers, GET_KEYBOARD_SHORTCUTS,
}) => ({
  user: UserReducers.user,
  GET_KEYBOARD_SHORTCUTS_DATA: GET_KEYBOARD_SHORTCUTS.data,
});

const mapDispatchToProps = () => ({});

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(KeyboardShortcutHandler));
